import { Component, Input } from '@angular/core';
import { ChecksComponent } from '../../../../../processes/components/checks/checks.component';
import { CHECK, IProcessDetailResponse } from '../../../../../processes/models/processes.models';

/**
 * Contraste documentos (OCR nombre/apellidos vs registro) en comprobaciones de detalle de operación.
 */
@Component({
	selector: 'app-operation-documents-checks-compare-info',
	imports: [ChecksComponent],
	templateUrl: './operation-documents-checks-compare-info.component.html',
	styleUrl: './operation-documents-checks-compare-info.component.scss',
})
export class OperationDocumentsChecksCompareInfoComponent {
	@Input({ required: true }) checksDetail!: IProcessDetailResponse;

	protected readonly checks: CHECK[] = [CHECK.DOCUMENTS_EXTERNAL_COMPARE];
}
